import '../assets/NcGuestContent-BLJ37yLM.css';
import { n as normalizeComponent } from "../chunks/_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const _sfc_main = {
  name: "NcGuestContent",
  mounted() {
    document.getElementById("content").classList.add("nc-guest-content");
  },
  destroyed() {
    document.getElementById("content").classList.remove("nc-guest-content");
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { attrs: { "id": "guest-content-vue" } }, [_vm._t("default")], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "cbad78fb"
);
const NcGuestContent = __component__.exports;
export {
  NcGuestContent as default
};
